$.extend(theme.PluginParallax.defaults, {
  parallaxHeight: '150%',
  speed: 1.2
});